import {isNotNil} from 'ramda';

import {CompositionFont} from '@dms/api/sales';
import i18n from '@dms/i18n';

import {BOLD_FONT_WEIGHT} from './toFontFacePatch';

/**
 * Names an uploaded face with the weight and style labels of the upload form, e.g.
 * "Roboto Bold Italic". A weight other than bold reads as Regular, as in `toFontFacePatch`.
 */
export const getFontFaceLabel = (face: Pick<CompositionFont, 'family' | 'weight' | 'style'>) =>
  [
    face.family,
    face.weight === BOLD_FONT_WEIGHT
      ? i18n.t('entity.watermark.composition.labels.bold')
      : i18n.t('entity.watermark.composition.labels.regular'),
    face.style === 'italic' ? i18n.t('entity.watermark.composition.labels.italic') : null,
  ]
    .filter(isNotNil)
    .join(' ');
